const changeElementVisibility = (selector, visibility) => {
	const el = document.querySelector(selector);
	if (el) {
		setTimeout(() => {
			el.style.visibility = visibility;
		}, 0);
	}
};

export const hideElement = (selector) => {
	changeElementVisibility(selector, 'hidden');
};

export const showElement = (selector) => {
	changeElementVisibility(selector, 'visible');
};
